import { gql } from "@edreamsodigeo/frontend-api-client";

export const GET_CURRENT_SESSION_NO_UPDATE = gql`
  query GetCurrentSession @ignore_update {
    listLoginSessions {
      currentSession {
        id
        creationTimestamp
      }
    }
  }
`;
